import { Flex, Progress } from 'antd';
import { theme } from 'styles/colors';
import { calculateProgressBarPercentage } from '../calculateProgressBarPercentage';

interface ProgressBarTierMarkersProps {
  amount: number;
}

export function ProgressBarTierMarkers(
  props: ProgressBarTierMarkersProps
): React.ReactElement {
  return (
    <div>
      <Flex gap={16}>
        <Progress
          percent={calculateProgressBarPercentage(props.amount)}
          showInfo={false}
          status="normal"
          strokeColor={theme.secondary}
        />
      </Flex>
      {/* <svg style={{ width: "100%", height: 40, background: 'blue' }} viewBox="0 0 100 40">
        <rect x={0} y={0} width={400} height={40} fill='red'/>
        {thresholds.map((threshold, index) => (
          <text
            key={index}
            x={`${calculateProgressBarPercentage(threshold)}%`}
            y="10"
            fontSize="12"
            fill={theme.primary}
          >
            {threshold}
          </text>
        ))}
      </svg> */}
    </div>
  );
}
